import script from "./PartThree.vue?vue&type=script&setup=true&lang=js"
export * from "./PartThree.vue?vue&type=script&setup=true&lang=js"

import "./PartThree.vue?vue&type=style&index=0&id=9143cf48&lang=less"
import "./PartThree.vue?vue&type=style&index=1&id=9143cf48&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9143cf48"]])

export default __exports__